import { useCallback, useSyncExternalStore } from 'react';
import { keepSignedInOnDevice, subscribeKeepSignedInOnDevice } from './authDevicePreference';

export function useKeepSignedInOnDevice(uid: string | null | undefined): boolean {
  const subscribe = useCallback((changed: () => void) => subscribeKeepSignedInOnDevice(uid, changed), [uid]);
  const snapshot = useCallback(() => keepSignedInOnDevice(uid), [uid]);
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
